import { useNavigation } from '@react-navigation/native';
import { images } from '_/space-management/assets';
import { Button, Text } from '_/space-management/components';
import { colors } from '_/space-management/constants/theme';
import { useSpaceContext } from '_/space-management/hooks/SpaceContext';
import { getSpaceTypeColor } from '_/space-management/services/models/enums/space-type.enum';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, View } from 'react-native';

import styles from './styles';
import { fontSizes } from '_/config/theme';

export default function ClosedLocation() {
  const navigation = useNavigation<any>();
  const { spaceType } = useSpaceContext();
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <Image source={images.closedLocation} />
      <Text fontSize={fontSizes.lg2} fontType="bold" style={[styles.text, styles.topText]}>
        {t('spaceManage.closedSpace.closedSpaceMessage')}
      </Text>
      <Text fontSize={fontSizes.lg} style={[styles.text, styles.topText]}>
        {t('spaceManage.closedSpace.pickOtherDate')}
      </Text>
      <Button
        backgroundColor={getSpaceTypeColor(spaceType)}
        textColor={colors.white}
        onPress={() => navigation.goBack()}
      >
        {t('spaceManage.closedSpace.goBackToPicker')}
      </Button>
    </View>
  );
}
